import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AdminUtilityPage } from './admin-utility';

@NgModule({
  declarations: [
    AdminUtilityPage,
  ],
  imports: [
    IonicPageModule.forChild(AdminUtilityPage),
  ],
})
export class AdminUtilityPageModule {}



// WEBPACK FOOTER //
// ./src/pages/admin-utility/admin-utility.module.ts